export default __webpack_public_path__ + "static/stages-title-96ff22544d0c60db7956a6acc2c750da.png";